import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'dark' | 'light';
};
export function Countdown({
  tone = 'dark'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const unitClass = tone === 'dark' ? 'bg-ink-800 text-cream border-ink-600' : 'bg-white text-ink border-ink/10';
  const labelClass = tone === 'dark' ? 'text-cream/50' : 'text-ink/50';
  const units = [{
    value: hours,
    label: 'horas'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <div className="flex items-stretch justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-45" data-mp="323ybyvktpq06">
      {units.map(unit => <div key={unit.label} className={`flex min-w-[76px] flex-col items-center rounded-xl border px-3 py-2.5 sm:min-w-[92px] ${unitClass}`} data-id="element-46" data-mp="10dmy3kg9of7h">
          <span className="font-display text-3xl font-extrabold tabular-nums sm:text-4xl" data-id="element-47" data-mp="y0mzvkh4h18g">
            {unit.value}
          </span>
          <span className={`mt-0.5 text-[11px] font-semibold uppercase tracking-[0.18em] ${labelClass}`} data-id="element-48" data-mp="t1k8v3xz8vjh">
            {unit.label}
          </span>
        </div>)}
    </div>;
}